export enum QueueStatus {
  ACTIVE = 'Active',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
}

export enum CoreQueueType {
  PHOTO_UPLOAD = 'photo-upload',
  CLOSE_EVENT = 'close-event',
}

export interface QueueResponse {
  id: string;
  type: CoreQueueType;
  status: QueueStatus;
  lastExecutedAt: string | null;
  lastErrorAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface InitiateQueueResponse {
  queueId: string;
}
